import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { isSafari } from 'react-device-detect';
import type { FasceOrarie } from './FasceOrarieUtils';
import type { OrariFinestra, OrariGiorno } from './FinestraOraria';

const isElencoFasce = (
  orariGiorno: OrariGiorno
): orariGiorno is readonly FasceOrarie[] => Array.isArray(orariGiorno);

// Il giorno ha almeno una fascia d'inizio in una delle sue bande: è aperto
const haFasce = (orariGiorno: OrariGiorno | null | undefined): boolean => {
  if (!orariGiorno) return false;
  const elenco = isElencoFasce(orariGiorno) ? orariGiorno : [orariGiorno];
  return elenco.some((fasce) => !!(fasce.startTime1 || fasce.startTime2));
};

/**
 * Giorni che il Lavorativo nasconde (colonna larga 0px), da lunedì (indice 0) a
 * domenica (6): quelli assenti dagli orari o senza fasce, in nessuna delle bande
 * del giorno (il Personale ne ha una per punto vendita). Il giorno selezionato
 * resta sempre visibile, perché useWorkWeekColumns lo allarga; su Safari e senza
 * orari non si nasconde nulla. Con una mappa vuota (chiuso tutta la settimana,
 * orari in errore) resta solo il selezionato.
 *
 * La stessa regola decide le colonne del Lavorativo (useWorkWeekColumns
 * dell'agenda negozio e del Personale) e i giorni che contano per la finestra
 * della funzione «Solo orario» (useFinestraOraria): un appuntamento in una
 * colonna larga 0px non si vede e non deve allargare la finestra.
 */
export function getGiorniChiusiLavorativo(
  selectedDate: Date | string,
  orari: OrariFinestra | null | undefined,
  safari: boolean = isSafari
): boolean[] {
  const selezionato = dayjs(selectedDate).startOf('date');
  const lunedi = selezionato.locale('it').startOf('week');
  return Array.from({ length: 7 }, (_, indice) => {
    if (!orari || safari) return false;
    const giorno = lunedi.add(indice, 'days');
    if (giorno.isSame(selezionato, 'day')) return false;
    return !haFasce(orari[giorno.format('YYYY-MM-DD')]);
  });
}
